export const getLabels = (type: string) => {
  return {
    title: `Common:ResourceType.${type}`,
    createDescription: `Admin:Contents.${type}Description`,
  };
};

export type ContentLabelsType = ReturnType<typeof getLabels>;
